import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgBcCard({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0h24v24H0V0z"
        fill="#fff"
        fillOpacity={0.01}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.434 4.894C7.974 3.592 9.868 3 12 3c2.487 0 4.5.829 6.276 2.606C20.052 7.383 21 9.514 21 12.001c0 2.487-.948 4.618-2.724 6.394C16.5 20.171 14.486 21 12 21c-2.487 0-4.619-.828-6.395-2.605C3.83 16.62 3 14.488 3 12.001c0-.829.118-1.54.237-2.132-.237 2.96.474 5.21 2.013 6.513a6.872 6.872 0 011.54-1.776c.828-.474 1.183-1.066 1.302-1.658.355-2.132-.237-3.197-1.777-3.197.83-2.132.592-2.961-.71-2.606-.592.355-1.184.829-1.658 1.54l-.71 1.065c.473-2.013 1.539-3.553 3.197-4.856zm5.21-.473c1.896-.119 3.08.473 3.435 1.776l-1.505.251-.627.105c-.237-.592-.71-.948-1.42-.83-1.066.12-1.54.592-1.54 1.658.118 1.54.71 2.25 1.894 2.37 1.066 0 1.659-.593 1.54-1.777l2.25-.237c.415 1.968-.35 3.302-2.372 3.843-1.036.276-2.277.469-3.312.153C8.645 11.325 7.56 9.772 7.469 8.4c-.09-1.324.656-2.785 1.845-3.42.591-.318 1.368-.484 2.33-.558zM4.74 10.379l-.673.674-.238-.83.674-.77c.166-.188.618-.366.634.034.005.12-.04.284-.125.487a1.109 1.109 0 01-.272.405zm1.293 2.414c-.2.236-.553.532-1.02.865-.236-.237-.354-.71-.473-1.303l.83-.829c.443-.221.703-.166.805.109.123.33.089.883-.142 1.158z"
        fill="#CC262D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0h24v24H0V0z"
        fill="#fff"
        fillOpacity={0.01}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.434 4.894C7.974 3.592 9.868 3 12 3c2.487 0 4.5.829 6.276 2.606C20.052 7.383 21 9.514 21 12.001c0 2.487-.948 4.618-2.724 6.394C16.5 20.171 14.486 21 12 21c-2.487 0-4.619-.828-6.395-2.605C3.83 16.62 3 14.488 3 12.001c0-.829.118-1.54.237-2.132-.237 2.96.474 5.21 2.013 6.513a6.872 6.872 0 011.54-1.776c.828-.474 1.183-1.066 1.302-1.658.355-2.132-.237-3.197-1.777-3.197.83-2.132.592-2.961-.71-2.606-.592.355-1.184.829-1.658 1.54l-.71 1.065c.473-2.013 1.539-3.553 3.197-4.856zm5.21-.473c1.896-.119 3.08.473 3.435 1.776l-1.505.251-.627.105c-.237-.592-.71-.948-1.42-.83-1.066.12-1.54.592-1.54 1.658.118 1.54.71 2.25 1.894 2.37 1.066 0 1.659-.593 1.54-1.777l2.25-.237c.415 1.968-.35 3.302-2.372 3.843-1.036.276-2.277.469-3.312.153C8.645 11.325 7.56 9.772 7.469 8.4c-.09-1.324.656-2.785 1.845-3.42.591-.318 1.368-.484 2.33-.558zM4.74 10.379l-.673.674-.238-.83.674-.77c.166-.188.618-.366.634.034.005.12-.04.284-.125.487a1.109 1.109 0 01-.272.405zm1.293 2.414c-.2.236-.553.532-1.02.865-.236-.237-.354-.71-.473-1.303l.83-.829c.443-.221.703-.166.805.109.123.33.089.883-.142 1.158z"
        fill="#CC262D"
      />
    </svg>
  )
}

export default SvgBcCard
